import type { CarStats } from '../../core/types';

const STAT_LABELS: Array<[keyof CarStats, string]> = [
  ['acceleration', 'Acceleration'],
  ['topSpeed', 'Top speed'],
  ['handling', 'Handling'],
  ['grip', 'Grip'],
];

export function StatBars({ stats, compact = false }: { stats: CarStats; compact?: boolean }) {
  return (
    <div className={`stat-bars ${compact ? 'stat-bars--compact' : ''}`}>
      {STAT_LABELS.map(([key, label]) => (
        <div className="stat-row" key={key}>
          <span>{label}</span>
          <div className="stat-row__track" aria-label={`${label}: ${stats[key]} out of 10`}>
            <i style={{ width: `${stats[key] * 10}%` }} />
          </div>
          <b>{stats[key]}</b>
        </div>
      ))}
    </div>
  );
}
